import NewsletterSignupForm from "./NewsletterSignupForm";
import { trackEvent } from "../lib/telemetry";

export default function FooterSignup() {
  function trackSignup(email) {
    trackEvent("Conversion", {
      "Conversion Type": "newsletter_signup",
      "Conversion Value": 1,
      source: "site-footer",
      email_domain: email.split("@")[1] || "unknown",
    });
  }

  return (
    <section id="updates" className="footer-signup" aria-labelledby="footer-signup-title">
      <div className="footer-signup__inner">
        <div className="footer-signup__copy">
          <h2 id="footer-signup-title">Stay in the story.</h2>
          <p>Publication news and occasional notes from R A Hewitt.</p>
        </div>
        <NewsletterSignupForm inputId="footer-newsletter-email" submitLabel="Keep me informed" idleMessage="" onSubmit={trackSignup} />
      </div>
    </section>
  );
}
